import { Link } from "gatsby"
import PropTypes from "prop-types"
import React, { useState } from "react"
import { StaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"
import { motion, useCycle } from "framer-motion"
import Celebration from "./celebration.js"
import logo from "../images/brand/Logo/Primary/Small/PNG/Primary Logo - Small.png";
import MobileHeader from "./mobileHeader"
import headerStyles from "./newLessonHeader.module.css"
import lessonLayout from "./lessonLayout.module.css"
import TOC from "./toc"
import Feedback2 from "./feedback2"

const LessonHeader = (props, data) => {
    const [progressPercentage, setProgressPercentage] = useState(0);
    return (
        <>
            <div className={lessonLayout.header}>
                <div className={headerStyles.headerWrapper}>
                    <header>
                        <div style={{display:"grid", gridTemplateColumns: "1fr auto 1fr"}}>
                            <div style={{whiteSpace:"nowrap"}}>
                                <h5 className={headerStyles.navLink}>
                                    <Link to="/">
                                        Home
                                    </Link>
                                </h5>
                                <h5 className={headerStyles.navLink + (props.location === "/lessons" ? (" " + headerStyles.currentPage) : "")}>
                                    <Link to="/lessons">
                                        Math Lessons
                                    </Link>
                                </h5>
                                <h5 className={headerStyles.navLink}>
                                    <Link to="/app/login">
                                        SAT Prep
                                    </Link>
                                </h5>
                                <h5 className={headerStyles.navLink + (props.location === "/guides" ? (" " + headerStyles.currentPage) : "")}>
                                    <Link to="/guides">
                                        Blog
                                    </Link>
                                </h5>
                            </div>
                            <div>
                                <Link to="/">
                                    <img src={logo} style={{width: "100px", marginTop:"-15px", marginBottom:"-10px"}}/>
                                </Link>
                            </div>
                            <div style={{textAlign:"right", whiteSpace:"nowrap"}}>
                                <h5 className={headerStyles.navLink + (props.location === "/for-teachers" ? (" " + headerStyles.currentPage) : "")}>
                                    <Link to="/for-teachers">
                                        For Teachers
                                    </Link>
                                </h5>
                                <h5 className={headerStyles.navLink + (props.location === "/about" ? (" " + headerStyles.currentPage) : "")}>
                                    <Link to="/about">
                                        About Us
                                    </Link>
                                </h5>
                                <h5 className={headerStyles.navLink}>
                                    <a href="https://www.bonfire.com/store/almost-fun/" target="_blank">
                                        Merch
                                    </a>
                                </h5>
                                <h5 className={headerStyles.navLink}>
                                    <a href="https://secure.givelively.org/donate/almost-fun-inc" target="_blank">
                                        Donate
                                    </a>
                                </h5>
                            </div>
                        </div>
                    </header>
                </div>
                <MobileHeader location={props.location} />
            </div>
            { props.tocData
                ?
                    <>
                        <div className={`${lessonLayout.toc} ${headerStyles.desktopOnly}`}>
                            <div style={{minHeight:"90vh", maxHeight:"90vh", position:"sticky", top:"70px", width:"280px", minWidth:"280px", maxWidth:"280px"}}>
                                <div style={{minHeight:"90vh", maxHeight:"90vh", position:"relative"}}>
                                    <div>
                                        <TOC
                                          tocData={props.tocData}
                                          updateProgressPercentage={(progressPercentage) => setProgressPercentage(progressPercentage)}
                                          toggleMobileFeedback={props.toggleMobileFeedback} />
                                    </div>
                                    <div>
                                        <Feedback2 name={props.name} tocData={props.tocData} />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={`${lessonLayout.toc} ${headerStyles.mobileOnly}`}>
                            <TOC
                              tocData={props.tocData}
                              updateProgressPercentage={(progressPercentage) => setProgressPercentage(progressPercentage)}
                              toggleMobileFeedback={props.toggleMobileFeedback} />
                        </div>
                    </>
                : null
            }
        </>
    )
}

export default LessonHeader
